export default __webpack_public_path__ + "static/media/DAIF_Menu.189b9a89.jpg";